import React from "react";

import Card from "@material-ui/core/Card";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Tooltip from '@mui/material/Tooltip';
import LinkIcon from '@mui/icons-material/Link';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import LinearProgress from '@mui/material/LinearProgress';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';

import Style from "../../../../styles/js/Styles";
import Image from "../../../utils/image";
import ImageViewer from "../../../utils/image-viewer"
import service from '../../../../plas/services/notices/service';
import { TimeDate } from "../../../../plas/utils/times/models"

function NoticeItem({ notice, canEdit, onEdit, onOpen, disable, updating}) {

  const style = Style();

  const ColoredLine = ({ color }) => (
      <hr
          style={{
              color: color,
              backgroundColor: color,
              marginTop: 0,
              marginBottom: 12,
              height: 1
          }}
      />
  );

  const [blobUrl, setBlobUrl] = React.useState(null);

  const closeImage = () => {
    setBlobUrl(null);
  }

  const openUrl = () => {
    var win = window.open(notice.url, '_blank');
    win.focus();
  }

  return (
    <Grid container spacing={0}>
       <Grid item>
        <p style={{ marginTop: 8, marginBottom: 4, fontSize: 17, color: 'gray', textAlign: 'left'}}>
          { notice.getCategory() }
        </p>
      </Grid>
      <Grid item xs={true}/>
      <Grid item>
        <p style={{ marginTop: 8, marginBottom: 4, fontSize: 17, color: 'gray', textAlign: 'right'}}>
          { new TimeDate(notice.creationTime).asDateTimeText() }
        </p>
      </Grid>
      <Grid item xs={12}>
        <Card elevation={0} >
          { updating ? (<LinearProgress />) : (<div style={{height: 4}}/>)}
          <Card style={{ textAlign: 'left', marginBottom: 8 }}>
            <Grid container spacing={2}>
              <Grid item xs={true}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="100%"> 
                            { notice.binId && (
                              <Card elevation={0}>
                                <Image 
                                  onClick={(url) => { setBlobUrl(url) }}
                                  url={service.api.notices.getMediaUrl(notice.id,notice.binId)} 
                                  containerProps={{style:{height: '100%'}}}
                                  imgProps={{ className: style.selectable, style:{ width: 150, maxHeight: 251, objectFit: 'contain', height: '100%'}}}
                                />
                              </Card>)
                            }                          
                        </Box>
                      </Grid>
                      <Grid item xs={true}>
                        <Grid container style={{ paddingRight: '16px'}}>
                          <Grid item xs={true}>
                            <p className={style.ellipseableText} style={{ 'WebkitLineClamp': 2, paddingTop: 12, marginBottom: '0.4rem', fontSize: 16, color: '#6C6C6C', textAlign: 'left'}}>
                              <b>{notice.title}</b>
                            </p>
                          </Grid>
                          <Grid item>
                            <div style={{paddingTop: 4}}>
                              { notice.alert && (
                                <Tooltip title="Noticia importante">
                                  <IconButton>
                                    <NotificationImportantIcon fontSize="small"/>
                                  </IconButton>
                                </Tooltip>
                              )}
                              { notice.url && 
                                (<Tooltip title="Abrir URL">
                                  <span>
                                    <IconButton disabled={disable} onClick={openUrl}>
                                      <LinkIcon fontSize="small"/>
                                    </IconButton>
                                  </span>
                                </Tooltip>)
                              }
                              <Tooltip title="Ver">
                                <span>
                                  <IconButton disabled={disable} onClick={() => {onOpen(notice)}}>
                                    <VisibilityRoundedIcon fontSize="small"/>
                                  </IconButton>
                                </span>
                              </Tooltip>
                              { canEdit && (
                                <Tooltip title="Editar">
                                  <span>
                                    <IconButton disabled={disable} onClick={() => { onEdit(notice) }}>
                                      <EditRoundedIcon fontSize="small"/>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                          </Grid>
                          <Grid item xs={12}>
                            <ColoredLine />
                          </Grid>
                          <Grid item xs={12} style={{marginBottom: 53}}>
                            <p className={style.ellipseableText} style={{ 'WebkitLineClamp': 4, marginBottom: 0, fontSize: 15, color: 'black', textAlign: 'left' }}>
                              <i>{notice.body}</i>
                            </p>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Card>
      </Grid>

      <ImageViewer open={blobUrl? true : false} url={blobUrl} onClose={closeImage} />

    </Grid>
  );

}

export default NoticeItem;
